module.exports = __webpack_public_path__ + "static/media/jiri-soul.ecfc6154.md";